import { AfterViewInit, Component, ElementRef, Input, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { environment } from 'src/environments/environment';
import { SharedService } from 'src/app/shared/services/shared.service';
import { Subscription } from 'rxjs';
import videojs, { VideoJsPlayer } from 'video.js';
import { ChangeDetectorRef } from '@angular/core';

declare var $: any;  // For jQuery (Bootstrap 4 depends on jQuery)
declare var bootstrap: any;

@Component({
  selector: 'app-great-ind-bazaar',
  templateUrl: './great-ind-bazaar.component.html',
  styleUrls: ['./great-ind-bazaar.component.css']
})
export class GreatIndBazaarComponent implements OnInit, AfterViewInit{  
  staticUrlForImgNew: string = environment.staticUrlForImgNew;
  @ViewChild('videoPlayer', { static: false }) videoElement!: ElementRef;
  player!: VideoJsPlayer;
  // @ViewChild('carousel', { static: false }) carousel!: ElementRef;
  // @ViewChild('carousel2', { static: false }) carousel2!: ElementRef;
  @ViewChildren('carousel') carousels!: QueryList<ElementRef>;

   bazarSubTitle;
   bazarTitle;
   bazarCards:any=[];
  contactKeyArray = [];
  subscription;
  SlidesAutomaticTimeInterval:number =  5;

  isVisible = false;
  videoSrc: string = '';

  constructor(public _sharedService: SharedService,
    private cdr: ChangeDetectorRef
  ) {
    this.getContactKeys();

   }

  ngOnInit(): void {
    this.getContactUsPageContent();
    console.log(this.bazarCards)
  }

  ngAfterViewInit() {
    // setTimeout(() => {
    //   const intervalTime = (this.SlidesAutomaticTimeInterval || 3) * 1000;
  
    //   this.carousels.forEach((carouselRef: ElementRef) => {
    //     ($(carouselRef.nativeElement) as any).carousel({
    //       interval: intervalTime,
    //       ride: 'carousel'
    //     });
    //   });
    // }, 100);

    $('#nma-about-modal1').on('hidden.bs.modal', () => {
      if (this.player) {
        this.player.pause();
      }
    });
    this.videoElement.nativeElement.addEventListener('ended', () => {
      $('#nma-about-modal1').modal('hide');
    });
  }
  

    // if (this.carousel) {
    //   $(this.carousel.nativeElement).carousel({
    //     interval: 2500,
    //     ride: 'carousel'
    //   });
    // }
    // if (this.carousel2) {
    //   $(this.carousel2.nativeElement).carousel({
    //     interval: 2500,
    //     ride: 'carousel2'
    //   });
    // }
  
  get visibleSections() {
    return this.bazarCards.filter(s => s.HideCard.data !== 'true');
  }


  getContactKeys() {
    
    return this.contactKeyArray = [      
      'NMACC-NYC-BAZAAR',      
    ];
    
}

getContactUsPageContent() {
  this.subscription = this._sharedService.getCommonService().getlandingUrl(this.contactKeyArray).subscribe(
    (data: any) => { 
      
      const rawData1 = data[0]?.data;
      this.SlidesAutomaticTimeInterval = parseInt((JSON.parse(rawData1?.SlidesAutomaticTimeInterval.data || '["1000"]'))[0], 10);

      
      this.bazarCards = (rawData1?.cards || [])
    .filter(card => card?.HideCard?.data !== 'true')
    .sort((a, b) => {
    const seqA = parseInt(a?.Sequence?.data || '0', 10);
    const seqB = parseInt(b?.Sequence?.data || '0', 10);
    return seqA - seqB;
  });

      

    
      
      this.bazarTitle = rawData1?.Title?.data;
      this.bazarSubTitle = rawData1?.SubTitle?.data;

      this.cdr.detectChanges();

      // 🚀 Now safely init carousels after rendering
      setTimeout(() => {
        const intervalTime = (this.SlidesAutomaticTimeInterval || 3) * 1000;
        this.carousels.forEach((carouselRef: ElementRef) => {
          ($(carouselRef.nativeElement) as any).carousel({
            interval: intervalTime,
            ride: 'carousel'
          });
        });
      }, 100); 

     })

}


openVideoModal(src: string, fileExtension:string) {
  this.videoSrc = this.staticUrlForImgNew+src;
  const mimeType = fileExtension === 'mp4'
  ? 'video/mp4'
  : 'application/x-mpegURL';

  // Show Bootstrap modal
  $('#nma-about-modal1').modal('show');

  // Delay to allow DOM modal to render before initializing player
  setTimeout(() => {
    if (!this.player) {
      this.player = videojs(this.videoElement.nativeElement, {
        autoplay: false,
        controls: true,
        sources: [
          {
            src: this.videoSrc,
            type: mimeType,
          },
        ],
      });
    } else {
      this.player.src({ src: this.videoSrc, type: mimeType });
      this.player.play();
    }
  }, 300);
}

close() {
  this.isVisible = false;
  if (this.player) {
    this.player.pause();
    $('#nma-about-modal1').modal('hide');
  }
}
}

     

      


